 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"eb039753a234aea90586828358ac68d5c76f974d","1":"35eb642be59a2d1e9b62d656c04fff89523d2c38","2":"bb3c9c3630ad74d60fa06840f58f50ad8781a242","3":"5c1fdf80f393a3fe5dd932d8abe6f3b0f8819475","4":"11094b64fe0f73baf096c7d6382dea9feaba11f0","5":"4ce66008320cab0bf97b058012303f7443ad6e55","6":"0c092a2dd35bfc90dc31f3d90ee44bf83d05be92","7":"252f366e","8":"9bb998ff","9":"component---src-templates-service-tsx","10":"95b64a6e","11":"4df98d9072a48f957579a375500f8fb8f57a56de","12":"styles","13":"5be3fb6f53087a849016cfe8f21210dbdee96a77","14":"74b743768d7224142612e67f8be2d772e20516a1","15":"component---src-pages-services-tsx","18":"456ebb50","21":"component---src-pages-404-tsx","22":"component---src-pages-company-tsx","23":"component---src-pages-contact-tsx","24":"component---src-pages-employees-tsx","25":"component---src-pages-family-clinic-tsx","26":"component---src-pages-guidance-tsx","27":"component---src-pages-index-tsx","28":"component---src-pages-jobs-tsx","29":"component---src-pages-kela-services-tsx","30":"component---src-pages-privacy-tsx","31":"component---src-pages-psychotherapies-tsx","32":"component---src-pages-qa-tsx","33":"component---src-pages-trainings-tsx","34":"component---src-templates-blog-tsx","35":"component---src-templates-blogs-tsx","36":"component---src-templates-current-tsx","37":"component---src-templates-training-tsx","38":"d19d7564","39":"e19d6005"}[chunkId]||chunkId) + "-" + {"0":"cb82f07f28d489019ff0","1":"a871152794408b6ed0d0","2":"005447b3d544675bad23","3":"3db98bc1d8a5887d615a","4":"a3321a5bf1320a6d5244","5":"9889b81f04e01489f7c1","6":"d6a7e375c82cca9fe8bb","7":"31da2527daa6ea1899c4","8":"9e52aef4a3c1124c96dc","9":"a171d6ba06f61ffdc8d9","10":"f0a88889f4d711871bae","11":"6e409721a08d36e8b00c","12":"31f023f48facb69035d3","13":"9a195b0d9e4c86847c52","14":"a64949cb6fdca8e293e5","15":"1d0cc0ad2d0e0220eea2","18":"0f70f09a705f086fac3d","21":"283cf7c8684d5b2f4994","22":"ad484e3dfbdb4cc9ec6a","23":"e067574cfd3f30626eec","24":"cd0750a7469203869cb6","25":"449b9e1cb15f8afa32b3","26":"7547a83d36d04b5eaac3","27":"26d7198549302349c1f1","28":"be059c950b87865aac16","29":"99a8a6f2f1deeaf51c0d","30":"9be30d622bab1e56bad0","31":"a2e75773e037ce32327f","32":"08abbe44c6e35a016b80","33":"4c9914d6b9d2ca8ce114","34":"5d3161fecc38581f7b00","35":"8ffadd48f7f92960b379","36":"ea2541ca6fd91ce4c6a4","37":"3c17fbbfc1ef2d1340c6","38":"2c5e1a1ad27dd828cdae","39":"b5bbb233bfbc586bd83d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"12":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"eb039753a234aea90586828358ac68d5c76f974d","1":"35eb642be59a2d1e9b62d656c04fff89523d2c38","2":"bb3c9c3630ad74d60fa06840f58f50ad8781a242","3":"5c1fdf80f393a3fe5dd932d8abe6f3b0f8819475","4":"11094b64fe0f73baf096c7d6382dea9feaba11f0","5":"4ce66008320cab0bf97b058012303f7443ad6e55","6":"0c092a2dd35bfc90dc31f3d90ee44bf83d05be92","7":"252f366e","8":"9bb998ff","9":"component---src-templates-service-tsx","10":"95b64a6e","11":"4df98d9072a48f957579a375500f8fb8f57a56de","12":"styles","13":"5be3fb6f53087a849016cfe8f21210dbdee96a77","14":"74b743768d7224142612e67f8be2d772e20516a1","15":"component---src-pages-services-tsx","18":"456ebb50","21":"component---src-pages-404-tsx","22":"component---src-pages-company-tsx","23":"component---src-pages-contact-tsx","24":"component---src-pages-employees-tsx","25":"component---src-pages-family-clinic-tsx","26":"component---src-pages-guidance-tsx","27":"component---src-pages-index-tsx","28":"component---src-pages-jobs-tsx","29":"component---src-pages-kela-services-tsx","30":"component---src-pages-privacy-tsx","31":"component---src-pages-psychotherapies-tsx","32":"component---src-pages-qa-tsx","33":"component---src-pages-trainings-tsx","34":"component---src-templates-blog-tsx","35":"component---src-templates-blogs-tsx","36":"component---src-templates-current-tsx","37":"component---src-templates-training-tsx","38":"d19d7564","39":"e19d6005"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"82f874e02c07c92c4532","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
